export const ReceiptTypes = {
  GET_RECEIPT: 'GET_RECEIPT',
}
